import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useShortlist } from "@/context/ShortlistContext";
import { VehicleCard } from "@/components/vehicle/VehicleCard";

export default function ShortlistPage() {
  const { ids, clear } = useShortlist();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!ids.length) { setItems([]); setLoading(false); return; }
    Promise.all(ids.map((id) => api.get(`/vehicles/${id}`).then((r) => r.data).catch(() => null)))
      .then((arr) => setItems(arr.filter(Boolean)))
      .finally(() => setLoading(false));
  }, [ids]);

  return (
    <div className="cs-container py-10" data-testid="shortlist-page">
      <div className="flex items-center justify-between">
        <h1 className="font-display font-extrabold text-3xl text-gray-900">Shortlisted Cars</h1>
        {ids.length > 0 && <button onClick={clear} className="text-sm font-semibold text-[#940C2C]">Clear all</button>}
      </div>
      {loading ? <div className="mt-8 text-gray-500">Loading…</div> : items.length === 0 ? (
        <div className="mt-10 border border-dashed border-gray-200 rounded-xl p-12 text-center">
          <p className="text-gray-600">You haven't shortlisted any cars yet.</p>
          <Link to="/buy" className="btn-primary mt-5 inline-flex">Browse Cars</Link>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((v) => <VehicleCard key={v.id} vehicle={v} />)}
        </div>
      )}
    </div>
  );
}
